import React, { useEffect, useRef, useState } from "react";

import Input from "../../components/input";
import RegularButton from "../../components/regularButton";
import { getApiUrl } from "../../config/api";

const MOBILE_PATTERN = /^09\d{9}$/;
const SUCCESS_MESSAGE_DURATION = 3000;

const normalizeDigits = (value) => value
  .replace(/[۰-۹]/g, (digit) => String("۰۱۲۳۴۵۶۷۸۹".indexOf(digit)))
  .replace(/[٠-٩]/g, (digit) => String("٠١٢٣٤٥٦٧٨٩".indexOf(digit)))
  .replace(/\D/g, "")
  .slice(0, 11);

const CustomerSubscriptionForm = () => {
  const [mobile, setMobile] = useState("");
  const [status, setStatus] = useState({ type: "", message: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const successTimer = useRef(null);

  useEffect(() => () => window.clearTimeout(successTimer.current), []);

  const clearSuccessTimer = () => {
    window.clearTimeout(successTimer.current);
    successTimer.current = null;
  };

  const handleChange = (event) => {
    clearSuccessTimer();
    setMobile(normalizeDigits(event.target.value));
    setStatus({ type: "", message: "" });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    clearSuccessTimer();

    if (!MOBILE_PATTERN.test(mobile)) {
      setStatus({
        type: "error",
        message: "شماره موبایل باید ۱۱ رقم و با ۰۹ شروع شود.",
      });
      return;
    }

    setIsSubmitting(true);
    setStatus({ type: "", message: "" });

    try {
      const response = await fetch(getApiUrl("customer"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ mobile: `+98${mobile.slice(1)}` }),
      });

      if (!response.ok) {
        throw new Error("Failed to register customer");
      }

      setMobile("");
      setStatus({
        type: "success",
        message: "شماره موبایل شما با موفقیت ثبت شد.",
      });
      successTimer.current = window.setTimeout(() => {
        setStatus({ type: "", message: "" });
      }, SUCCESS_MESSAGE_DURATION);
    } catch (error) {
      setStatus({
        type: "error",
        message: "ثبت شماره موبایل با خطا مواجه شد. لطفاً دوباره تلاش کنید.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form className="sign-up-form" onSubmit={handleSubmit} noValidate>
      <div className="label">در صورت تمایل برای دریافت اطلاع رسانی ها مشترک شوید.</div>
      <div className="form-controls">
        <div className="control-item phone-control">
          <Input
            aria-label="شماره موبایل"
            className={status.type === "error" ? "error" : ""}
            placeholder="شماره موبایل"
            type="tel"
            inputMode="numeric"
            pattern="09[0-9]{9}"
            maxLength="11"
            autoComplete="tel-national"
            dir="ltr"
            value={mobile}
            onChange={handleChange}
            disabled={isSubmitting}
          />
        </div>
        <div className="control-item">
          <RegularButton
            text={isSubmitting ? "در حال ارسال..." : "تایید"}
            isFull={true}
            type="submit"
            disabled={isSubmitting}
          />
        </div>
      </div>
      {status.message && (
        <div
          className={`subscription-message ${status.type}`}
          role={status.type === "error" ? "alert" : "status"}
        >
          {status.message}
        </div>
      )}
    </form>
  );
};

export default CustomerSubscriptionForm;
